export interface ArbitroGrupoJSON {
  arbg_id: string | null;
  arbg_nombre: string;
  arbg_activo: boolean;
}

export class ArbitroGrupo {
  protected constructor(private id: string | null, private nombre: string, private activo: boolean) {}

  static createFrom(id: string | null, nombre: string, activo: boolean) {
    return new this(id, nombre, activo);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: ArbitroGrupo) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: ArbitroGrupoJSON) {
    return ArbitroGrupo.createFrom(entity.arbg_id, entity.arbg_nombre, entity.arbg_activo);
  }

  toJSON(): ArbitroGrupoJSON {
    return {
      arbg_id: this.getId(),
      arbg_nombre: this.getNombre(),
      arbg_activo: this.getActivo(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getNombre(): string {
    return this.nombre;
  }

  getActivo(): any {
    return this.activo;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setNombre(value: string): void {
    this.nombre = value;
  }

  setActivo(value: any): void {
    this.activo = value;
  }
}
